import * as React from "react";
import TerminationFormFilter from "./components/TerminationFormFilter";
import TerminationFormTable from "./components/TerminationFormTable";
import IndexHeader from "app/shared-components/IndexHeader";
import CustomButton from "app/shared-components/CustomColorButton";

import SaveIcon from "@mui/icons-material/Save";
import CancelIcon from "@mui/icons-material/Cancel";
import AddIcon from "@mui/icons-material/Add";
import history from "@history";

  const handleClick = () => {
    history.push('termination-form/add');
  };


export default function WorksiteIndex() {
  const myButtons = [
    <CustomButton
      StartIcon={<AddIcon />}
      className="mx-9"
      disabled={false}
      onClick={handleClick}
      name="New"
      color="primary"
      variant="contained"
    ></CustomButton>,
  ];
  return (
    <>
      <IndexHeader
        name={"Termination Form Index"}
        update={false}
        add={false}
        buttons={myButtons}
      />
      <TerminationFormFilter />
      <TerminationFormTable />
    </>
  );
}
